import { MELCO_HOOP_VERSION } from "../../../helper/hoopHelper";
import { SelectField } from "melco-shared-logic";

type ThreadVersionSelectProps = {
    onChange?: (obj: any) => void;
    value?: string;
    // mode?: string;
}

export const ThreadVersionSelect: React.FC<ThreadVersionSelectProps> = ({ onChange, value }) => {

    let options = [];

    options = MELCO_HOOP_VERSION.split(",").map((v) => {
        return {
            label: v,
            value: v
        }
    })
    return <>
        <SelectField
            name="version"
            allowClear
            options={options}
            style={{ width: "100%", minWidth: "150px" }}
            // mode={mode == "multiple" ? "multiple" : undefined}
            value={"5"}
        //onChange={onChange}

        />
    </>
}